"use client"; // WICHTIG: Das macht es zu einer Client Component!

import Link from 'next/link';
import Image from 'next/image';

export default function NewsSlider({ news, strapiUrl }) {
  if (!news || news.length === 0) return null;

  // Diese Funktion wird nun sicher im Browser ausgeführt
  const scroll = (direction) => {
    const slider = document.getElementById('news-slider');
    if (slider) {
      const scrollAmount = direction === 'left' ? -320 : 320;
      slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section style={{ padding: '60px 0', backgroundColor: '#f9f9f9', borderTop: '1px solid #eee' }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <h2 style={{ fontSize: '2.5rem', color: 'var(--primary-color)', margin: 0 }}>Aktuelles</h2>
          
          <div className="slider-nav" style={{ display: 'flex', gap: '10px' }}>
            <button 
              onClick={() => scroll('left')}
              style={navButtonStyle}
              aria-label="Nach links scrollen"
            > ← </button>
            <button 
              onClick={() => scroll('right')}
              style={navButtonStyle}
              aria-label="Nach rechts scrollen"
            > → </button>
          </div>
        </div>

        <div 
          id="news-slider"
          style={{ 
            display: 'flex', 
            overflowX: 'auto', 
            scrollSnapType: 'x mandatory',
            gap: '20px',
            paddingBottom: '20px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }}
        >
          {news.map((item) => {
            const d = item.attributes || item;
            return (
              <Link 
                key={item.id} 
                href={`/aktuelles/${d.News_slug}`}
                style={{ 
                  minWidth: '300px', 
                  flex: '0 0 320px', 
                  scrollSnapAlign: 'start',
                  backgroundColor: '#fff',
                  borderRadius: '16px',
                  padding: '30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.05)',
                  textDecoration: 'none',
                  color: 'inherit',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  border: '1px solid #eee',
                  transition: 'transform 0.2s ease, borderColor 0.2s ease'
                }}
              >
                <div>
                  <span style={{ fontSize: '0.85rem', color: 'var(--accent-color)', fontWeight: 'bold' }}>
                    {d.PublishedDate ? new Date(d.PublishedDate).toLocaleDateString('de-DE') : ''}
                  </span>
                  <h3 style={{ fontSize: '1.4rem', marginTop: '15px', lineHeight: '1.4', color: 'var(--primary-color)' }}>
                    {d.Title}
                  </h3>
                </div>
                <div style={{ marginTop: '20px', fontWeight: '600', color: 'var(--accent-color)' }}>
                  Weiterlesen →
                </div>
              </Link>
            );
          })}
        </div>
      </div>
      <style dangerouslySetInnerHTML={{ __html: `
        #news-slider::-webkit-scrollbar { display: none; }
        .slider-nav button:hover { background-color: var(--accent-color) !important; color: white !important; border-color: var(--accent-color) !important; }
      `}} />
    </section>
  );
}

const navButtonStyle = {
  width: '45px', height: '45px', borderRadius: '50%', border: '1px solid #ddd',
  backgroundColor: '#fff', cursor: 'pointer', fontSize: '1.2rem',
  display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s ease'
};